// Cashier Debit & Credit Transactions Getters

export const getDebitCreditList = state => {
  return state.debitCreditList
}

export const getDebitCreditInfo = state => {
  return state.debitCreditInfo
}
